<template>
  <div id="registro" class="zindex10">
    <section id="fondo">
      <div class="container">
        <div class="row pt-5 mb-4">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>

        <div class="row">
          

          <div class="col-12 zindex10">
            <div class="row py-3">
              <div id="formregistro" class="col-12 z100 py-5 r15">
                <div class="success-screen text-center">
                  <div class="col-12 text-center pb-4 blanco zindex10 ">
                    <img src="../assets/imgs/dominos/crea-tu-cuenta-y-entra-al-juego.png" class="w-100 tituloseccion pb-5" alt="Crea tu cuenta">
                  </div>

                  <div class="success-check-wrap">
                    <img
                      src="../assets/imgs/dominos/check.png"
                      class="success-check"
                      width="50"
                      alt="Registro completado"
                    />
                    <span class="blanco fG bold"
                      >¡Registro completado!</span
                    >
                  </div>

                  <div class="success-code-wrap py-5 blanco fG ">
                    <p class="success-code-label bold">
                      Tu ID único de participante es:
                    </p>
                    <p class="success-code py-4 bold">
                      {{userProfile.user_id}}
                    </p>
                    <p class="success-code-note">
                      Guárdalo para consultar si fuiste<br />
                      un ganador.
                    </p>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 offset-lg-3">
                      <div class="success-player-wrap">
                        <img
                          src="../assets/imgs/dominos/ya-estas-dentro-del-juego.png"
                          class="img-fluid"
                          alt="Ya estás dentro del juego"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="success-message-wrap py-5">
                    <p class="blanco fG">
                      <b>Tu cuenta fue creada exitosamente.</b><br />
                      Ahora puedes <b>registrar tus tickets</b> de<br />
                      <b>Domino's</b> y empezar a sumar puntos<br />
                      para ganar premios.
                    </p>
                  </div>

                  <div class="success-btn-wrap">
                    <router-link to="/dashboard" class="btn btnaction maxw fG bold">
                      REGISTRAR TICKET
                    </router-link>
                  </div>

                  <div class="success-extra-link-wrap py-5 blanco fG bold underlined">
                    <a href="https://www.dominos.com.mx/" target="_blank" rel="noopener" class="success-extra-link">
                      Aún no tengo ticket, pero<br />
                      quiero una pizza
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">GANADORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de ganadores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/ganadores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de ganadores semanales
            </router-link>
          </div>
        </div> -->
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";
import moment from "moment";

import samsLogo from "../assets/imgs/flow/productos-participantes-sams.png";
import walmartLogo from "../assets/imgs/flow/productos-participantes-walmart.png";

import colgate1 from "../assets/imgs/datumax/productos/colgate-max-white.png";
import walmartPremios from "../assets/imgs/flow/premio-walmart.png";

import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      products: [
        {
          name: "Producto 1",
          description: "Este es el producto 1",
          image: "../assets/imgs/datumax/productos/colgate-max-white.png",
        },
        {
          name: "Producto 2",
          description: "Este es el producto 2",
          image: colgate1,
        },
        {
          name: "Producto 3",
          description: "Este es el producto 3",
          image: colgate1,
        },
        {
          name: "Producto 4",
          description: "Este es el producto 4",
          image: colgate1,
        },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero: "",
        terminosedad: "",
        terminos: "",
        terminoscondiciones: "",
        medio_de_contacto: "",
        estado: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      showPasswordLogin: false, // Para login
      showPasswordSignup1: false, // Para signup password
      showPasswordSignup2: false, // Para signup confirm
    };
  },
  mounted: function () {
    // // // try {
    // // //   if (typeof window.fbq === "function") window.fbq("track", "Lead");
    // // //   if (window.ttq && typeof window.ttq.track === "function")
    // // //     window.ttq.track("SubmitForm");

    // // //   const params = new URLSearchParams(window.location.search);
    // // //   const idl = params.get("idl");

    // // //   const gtagEventName =
    // // //     idl === "leadregistro2" ? "LeadRegistro2" : "LeadRegistro";

    // // //   if (typeof window.gtag === "function") {
    // // //     window.gtag("event", "conversion", {
    // // //       allow_custom_scripts: true,
    // // //       send_to: "DC-10549239/mx_ma0/latam000+standard",
    // // //     });

    // // //     window.gtag("event", gtagEventName, {
    // // //       send_to: "G-19Y3LCQ4F7",
    // // //     });
    // // //   }
    // // // } catch (error) {
    // // //   console.error("Error en eventos de tracking:", error);
    // // // }

    AOS.init({
      offset: -120,
      delay: 0,
      duration: 800,
      easing: "ease-in-out",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
      disable: "mobile",
    });

    const vm = this;
    setTimeout(() => {
      vm.explotar = false;
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
    logoSrc() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return samsLogo;
      if (tienda === "walmart") return walmartLogo;
      return "";
    },
    textoTienda() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return "Sam´s Club";
      if (tienda === "walmart") return "Walmart y Bodega Aurrera";
      return "";
    },
    groupedProducts() {
      const groups = [];
      for (let i = 0; i < this.products.length; i += 2) {
        groups.push(this.products.slice(i, i + 2));
      }
      return groups;
    },
  },
  methods: {
    scrollToForm() {
      const element = document.getElementById("formregistro");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        console.warn('Element with id="formregistro" not found.');
      }
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      // Validar contraseña
      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      // Confirmación de contraseña
      if (this.signupForm.password !== this.signupForm.password2) {
        swal.fire(
          "Oops",
          "La confirmación de contraseña no coincide con el campo de contraseña.",
          "warning"
        );
        return false;
      }

      // Validar teléfono
      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      // // Validar edad (18 años o más)
      // if (!this.signupForm.fecha_nacimiento) {
      //   swal.fire("Oops", "Debes ingresar tu fecha de nacimiento.", "warning");
      //   return false;
      // }

      // const fechaNacimiento = moment(
      //   this.signupForm.fecha_nacimiento,
      //   "YYYY-MM-DD"
      // );
      // const hoy = moment();
      // const edad = hoy.diff(fechaNacimiento, "years");

      // if (edad < 18) {
      //   swal.fire(
      //     "Oops",
      //     "Debes tener al menos 18 años para registrarte.",
      //     "warning"
      //   );
      //   return false;
      // }

      // Todo validado, registrar
      this.registro();
    },

    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminosedad: false,
        terminos: false,
        terminoscondiciones: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
